module.exports = __webpack_public_path__ + "static/media/nazanin.b2af20df.png";